// Coaching Institute Evidence — reuses the School Evidence page.
// Header/Footer auto-detect the `/coaching/*` path so Coaching nav & branding are applied.
import SchoolEvidence from '../school/SchoolEvidence';

export default SchoolEvidence;
